import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../config/authAxios";

const initialState = {
  status: null,
  loading: false,
  data: [],
  error: "",
  message: "",
};

export const createOfferAction = createAsyncThunk(
  "create-offer",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.post(`/admins/api/add/offer`, { ...data });
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createOfferSlice = createSlice({
  name: "create-offer",
  initialState,
  reducers: {
    resetCreateOfferState: (state) => {
      state.status = null;
      state.loading = false;
      state.data = [];
      state.error = "";
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createOfferAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createOfferAction.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload?.data;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
    builder.addCase(createOfferAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
  },
});

export const { resetCreateOfferState } = createOfferSlice.actions;
export const createOfferReducer = createOfferSlice.reducer;
